import {AboutTwoData} from "@/data";
import React from "react";
import {Col, Container, Row} from "react-bootstrap";

const AboutTwo = () => {
    const {caption, blockTitle, lists, offer} = AboutTwoData;

    function createMarkup() {
        return {__html: caption};
    }

    return (
        <section className="about_service_area section_padding">
            <Container>
                <Row>
                    <Col lg={6}>
                        <div className="about_service_left">

                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="about_service_right">
                            <div className="hero-title-with-shape">
                                <h4 className="heading_with_border">Rouge Multiservice</h4>
                                <h1>Una rete di servizi a tua disposizione</h1>
                            </div>
                            <p>
                                Offriamo una vasta gamma di servizi, che spaziano dalle pulizie al giardinaggio; dal trasporto merci (nazionale) al facchinaggio, fino alla gestione di magazzini e depositi
                                Il core business della Rouge Multiservice è proprio quello di offrire tutta la serie di servizi collegati allo sviluppo di un'azienda, con progetti e pacchetti di volta in volta declinati secondo le specifiche esigenze di ogni cliente.
                            </p>
                            <ul>
                                <li>
                                    <i className="fa fa-check-circle"></i> Pulizia
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i> Igienizzazione e sanificazione
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i> Disinfestazione
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i> Derattizzazione
                                </li>

                            </ul>

                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AboutTwo;
